import React from 'react';
import { Link } from 'gatsby';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as HsLinkStylesHs from './hs-link.hs.module.scss';
import * as HsLinkStylesDr from './hs-link.dr.module.scss';

const HsLink = ({
    children,
    to,
    type = 'standard',
    onClick = null,
    darkBackground = false,
    active = false,
    storyblokCommon,
}: {
    children: any;
    type?: 'standard' | 'copytext';
    to?: string;
    onClick?: any;
    darkBackground?: boolean;
    active?: boolean;
    storyblokCommon: StoryblokCommon;
}) => {
    const HsLinkStyles = storyblokCommon.configuration.content.theme === 'hs' ? HsLinkStylesHs : HsLinkStylesDr;

    return (
        <>
            {HsLinkStyles && (
                <>
                    {to ? (
                        <Link
                            to={to}
                            className={[
                                HsLinkStyles.hsLink,
                                HsLinkStyles[type],
                                darkBackground ? HsLinkStyles.darkBackground : '',
                                active ? HsLinkStyles.active : '',
                            ].join(' ')}
                            onClick={onClick}
                        >
                            {children}
                        </Link>
                    ) : (
                        <button
                            className={[
                                HsLinkStyles.hsLink,
                                HsLinkStyles[type],
                                darkBackground ? HsLinkStyles.darkBackground : '',
                                active ? HsLinkStyles.active : '',
                            ].join(' ')}
                            onClick={onClick}
                        >
                            {children}
                        </button>
                    )}
                </>
            )}
        </>
    );
};

export default HsLink;
